import { useState } from "react";
import axios from "axios";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Seo } from "@/components/site/Seo";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Customer Portal launcher. The user enters the email they paid with;
 * the backend looks up their stripe_customer_id and returns a Portal URL.
 */
const Billing = () => {
  const [email, setEmail] = useState("");
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const open = async (e) => {
    e.preventDefault();
    setError(null);
    if (!/.+@.+\..+/.test(email)) {
      setError("Enter the email you paid with.");
      return;
    }
    setSubmitting(true);
    try {
      const r = await axios.post(`${API}/billing/portal`, {
        email: email.trim().toLowerCase(),
        origin: window.location.origin,
      });
      if (r.data?.url) {
        window.location.assign(r.data.url);
      } else {
        setError("Couldn't open the billing portal.");
        setSubmitting(false);
      }
    } catch (err) {
      const detail = err?.response?.data?.detail || "Couldn't open the billing portal.";
      setError(detail);
      setSubmitting(false);
    }
  };

  return (
    <>
      <Seo title="Clearview — billing" description="Manage your subscription, change plan, update card or cancel — month to month, no lock-in." path="/billing" />
      <Header />
      <section className="ph">
        <div className="container">
          <div className="eyebrow eyebrow-light">Billing</div>
          <h1 style={{ marginTop: 14 }}>Manage your<br /><span className="gtext">subscription.</span></h1>
          <p className="lead">Change plan, update your card, or cancel — month to month, no lock-in. We hand you to Stripe's secure billing portal.</p>
        </div>
      </section>

      <section className="pad">
        <div className="container narrow-760">
          <form onSubmit={open} className="cv-billing-form" data-testid="billing-form">
            <label className="cv-field">
              <span>Email on the subscription</span>
              <input
                type="email"
                required
                autoComplete="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@yourbusiness.com.au"
                data-testid="billing-email-input"
              />
            </label>
            {error ? <div className="cv-error" role="alert" data-testid="billing-error">{error}</div> : null}
            <button type="submit" className="pill" disabled={submitting} data-testid="billing-submit">
              {submitting ? "Opening Stripe portal…" : "Open billing portal"}
            </button>
            <p className="cv-fine">
              The portal opens at Stripe. Your card, your subscription — managed there directly.
            </p>
          </form>
        </div>
      </section>
      <Footer />
    </>
  );
};

export default Billing;
